import { Directive, ElementRef, OnInit, Input, Renderer2, OnDestroy, DoCheck, HostListener } from '@angular/core';
import { LinkService } from '../services/link.service';
import { LinkGroup } from '../models/link-group.model';
import { Subscription } from 'rxjs';
import { SelectedShape } from '../models/selected-shape.model';
import { createBlurElement } from '../helpers/elements-svg.helper';

@Directive({
  selector: '[rteLinkContainer]'
})
export class LinkContainerDirective implements OnInit, DoCheck, OnDestroy {

  group : LinkGroup;

  subscription: Subscription = new Subscription();

  @Input('rteLinkContainer') groupName : string;

  constructor(private el: ElementRef,
              private linkService : LinkService,
              private renderer: Renderer2) { }

  ngOnInit(): void {
    if(this.el && this.groupName){
      this.linkService.setContentRefOnGroup(this.groupName, this.el.nativeElement);
      this.linkService.creteSVGOnGroup(this.groupName);
      this.group = this.linkService.getGroupByName(this.groupName);

      createBlurElement(this.group);
    }
  }

  ngDoCheck(){
    this.adjustSVGProportions();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    this.adjustSVGProportions();
  }

  adjustSVGProportions(){
    this.renderer.setAttribute(this.group.svgRef, 'width',this.getRelativeWidth());
    this.renderer.setAttribute(this.group.svgRef, 'height',this.getRelativeHeigth());
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getRelativeWidth(){
    let ref = this.group.contentRef;
    return ref.clientWidth + ref.scrollLeft
  }

  getRelativeHeigth(){
    let ref = this.group.contentRef;
    return ref.clientHeight + ref.scrollTop
  }
}
